// extracted by mini-css-extract-plugin
module.exports = {"productImageContainer":"az_wad","productImageLink":"az_xad","image":"az_yad","responsiveImage":"az_zad"};